import { useEffect, useState } from 'react';

import useSWR from 'swr';

import api from '@src/api';
import { ImageLinks } from '@src/utils/constants/MODE_INFERENCE_DEFAULTS';

interface useGetBlockDetails {
  blockName: string;
  blockVersion?: string;
  onError?: (error: unknown) => void;
}

const FetchBlockDetails = async (url: string) => {
  const response = await api.dexter.get(url);

  // for some reason dexter is sending array inside response.data.data
  return response.data.data[0];
};

export const useGetBlockDetails = ({
  blockName,
  blockVersion,
  onError
}: useGetBlockDetails) => {
  const [src, setSRC] = useState<string>('');

  const isFetchBlock = blockName;
  const isVersion = blockVersion;

  const { data = {}, isLoading } = useSWR(
    isFetchBlock
      ? `/blocks/${blockName}/${isVersion ? `?version=${blockVersion.replace(/^v/, '')}` : ''}`
      : null,
    FetchBlockDetails,
    {
      onError: error => onError?.(error),
      onErrorRetry: error => {
        if (error.status === 404) return;
      }
    }
  );

  useEffect(() => {
    const images: { [key: string]: string } = ImageLinks;
    if (blockName) setSRC(images[blockName]);

    return () => {
      setSRC('');
    };
  }, [blockName]);

  return {
    data,
    src,
    isLoading
  };
};
